import {useEffect, useState} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import Field from "components/helpers/form/field";
import {getSubscription, updateSubscription} from "custom/demo/requests/admin/validation-automated-reports";

export default function Subscription() {
  const {id} = useParams();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    getSubscription(id, email).then((data) => {
      if(data.error) { setError(data.error); return; }
      setReport(data.validation_automated_report);
    });
  }, [id, email]);

  if(error) { return <div className="container"><p>{error}</p></div>; }
  if(!report) { return <div className="container"><p>Loading...</p></div>; }

  const onChange = (event) => {
    setReport({...report, active: event.target.checked});
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setNotice(null);
    updateSubscription(id, email, {active: report.active}).then((data) => {
      if(data.error || data.errors) {
        setError(data.error || data.errors.join(", "));
        return;
      }
      setReport(data.validation_automated_report);
      setNotice("Subscription updated");
    });
  };

  return (
    <div className="container">
      <h1>Validation Automated Report</h1>
      <p>{report.name}</p>
      {notice && <p className="notice">{notice}</p>}
      <form onSubmit={onSubmit}>
        <Field
          checked={report.active}
          label="Active"
          name="active"
          onChange={onChange}
          type="checkbox"
        />
        <div className="mt-4">
          <button className="btn btn-blue" type="submit">Update</button>
        </div>
      </form>
    </div>
  );
}
